<div class="forgotpw">
  <div class="card col-12 col-md-3 offset-md-2 px-5 py-5">
    <img *ngIf="logo" class="mb-5 logo-edunet" [src]="logo" alt="logo">
    <div nz-form class="forgotpw-form">
      <ng-container *ngIf="isVerifyingEmail; else changePw">
        <nz-form-item>
          <nz-form-control
            [nzErrorTip]="mailErrTpl">
            <nz-input-group nzPrefixIcon="mail">
              <input type="text" nz-input [formControl]="email" placeholder="Email" />
            </nz-input-group>
            <ng-template #mailErrTpl>
              <ng-container *ngIf="email.hasError('required')">{{ 'forgotPw.requiredEmail' | transloco }}</ng-container>
              <ng-container *ngIf="!email.hasError('required')">{{ 'forgotPw.invalidEmail' | transloco }}</ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <button [disabled]="email.invalid" nz-button class="forgotpw-form-button mt-4" [nzLoading]="loading" [nzType]="'primary'"
          (click)="getVerifyCode()"
        >
          {{ 'forgotPw.getVerifyCode' | transloco }}
        </button>
        <div class="mt-4 align-items-center">
          <a href="https://www.facebook.com/nguoidankhanhhoanoitienganh">{{ 'forgotPw.fanpage' | transloco }}</a>
        </div>
        <div class="mt-4 d-flex align-items-center" style="font-size: 14px;">
          <a [routerLink]="'/login'"><i nz-icon nzType="double-left" nzTheme="outline"></i> {{ 'forgotPw.back' | transloco }}</a>
        </div>
      </ng-container>
      <ng-template #changePw>
        <nz-form-item>
          <nz-form-control
            [nzErrorTip]="verifyCodeErrTpl">
            <nz-input-group nzPrefixIcon="key">
              <input type="text" nz-input [formControl]="verifyCode" placeholder="{{ 'forgotPw.verifyCodePlaceholder' | transloco }}" />
            </nz-input-group>
            <ng-template #verifyCodeErrTpl>
              <ng-container *ngIf="verifyCode.hasError('required')">{{ 'forgotPw.requiredVerifyCode' | transloco }}</ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="mt-2">
          <nz-form-control [nzErrorTip]="pwErrTpl">
            <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplate">
              <input [type]="passwordVisible ? 'text' : 'password'" nz-input [formControl]="password" placeholder="{{ 'forgotPw.pwPlaceholder' | transloco }}" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="passwordVisible = !passwordVisible"></i>
            </ng-template>
            <ng-template #pwErrTpl>
              <ng-container *ngIf="password.hasError('required')">{{ 'forgotPw.requiredPw' | transloco }}</ng-container>
              <ng-container *ngIf="!password.hasError('required')">{{ 'forgotPw.invalidPw' | transloco }}</ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <ul class="pw-rule__list">
<!--          <li class="pw-rule__item">-->
<!--            <img *ngIf="!pwValidatorRes.letter" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">-->
<!--            <img *ngIf="pwValidatorRes.letter" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--            {{ 'forgotPw.charLengthPw' | transloco }}-->
<!--          </li>-->
<!--          <li class="pw-rule__item">-->
<!--            <img *ngIf="!pwValidatorRes.number" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">-->
<!--            <img *ngIf="pwValidatorRes.number" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--            {{ 'forgotPw.numberLengthPw' | transloco }}-->
<!--          </li>-->
<!--          <li class="pw-rule__item">-->
<!--            <img *ngIf="!pwValidatorRes.special" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">-->
<!--            <img *ngIf="pwValidatorRes.special" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--            {{ 'forgotPw.specialCharLengthPw' | transloco }}-->
<!--          </li>-->
          <li class="pw-rule__item">
            <img *ngIf="!pwValidatorRes.length" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">
            <img *ngIf="pwValidatorRes.length" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">
            {{ 'forgotPw.pwLength' | transloco }}
          </li>
        </ul>
        <button [disabled]="password.invalid || verifyCode.invalid" [nzLoading]="loading" nz-button class="forgotpw-form-button mt-4" [nzType]="'primary'"
          (click)="changePassword()"
        >
          {{ 'forgotPw.submitBtn' | transloco }}
        </button>
        <div class="mt-4 d-flex align-items-center" style="font-size: 14px;">
          <a href="" (click)="isVerifyingEmail=true;"><i nz-icon nzType="double-left" nzTheme="outline"></i> {{ 'forgotPw.back' | transloco }}</a>
        </div>
      </ng-template>
    </div>
    <div class="mt-5 hadtech-logo-container"><img class="hadtech-logo" src="assets/images/logo.svg" alt="logo"></div>
  </div>
</div>
